import { Policy } from '@commandDrivenStateEngine/core/policies';
import { AccountState } from '../state';
import { AccountCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
/**
 * Account Info Update Policy
 *
 * Responsibilities:
 * - React to info/save command
 * - Call UpdateAccountInfo API
 * - Update loading state on completion
 * - Handle errors
 */
export const createAccountInfoUpdatePolicy = (
  backend: ClientLibraryType,
  accountId: string
): Policy<AccountState, AccountCommand> => ({
  name: 'account-info-update',

  shouldReact: ( prev, next ) => {
    // React when saving goes from false to true
    return (
      !prev.accountInfo.loading.saving &&
      next.accountInfo.loading.saving &&
      next.accountInfo.editingField !== null
    );
  },

  onStateChange: async ({ next, ctx }) => {
    const { editingField, tempValue } = next.accountInfo;

    if ( !editingField ) {
      ctx.dispatch(
        { type: 'account/info/loading/setSaving', payload: { isSaving: false }},
        { source: 'api' }
      );
      return;
    }

    try {
      // Build update payload based on field
      const updatePayload: Record<string, any> = {};

      if ( editingField === 'businessName' ) {
        updatePayload.accountName = tempValue;
      }

      // Call backend
      await backend.commands.UpdateAccountInfo({
        id: accountId,
        body: updatePayload
      });

      // Success: reset loading and clear editing state
      ctx.dispatch(
        { type: 'account/info/loading/setSaving', payload: { isSaving: false }},
        { source: 'api' }
      );
    } catch ( error ) {
      console.error( '[account] Info update error:', error );

      // Reset loading state
      ctx.dispatch(
        { type: 'account/info/loading/setSaving', payload: { isSaving: false }},
        { source: 'api' }
      );

      // Keep editing state so user can retry
      // Throw error to trigger global error handler
      throw error;
    }
  }
});
